import React from 'react';
import '../styles/components/oauth-loading-overlay.css';

interface OAuthLoadingOverlayProps {
  isOpen: boolean;
  provider: string;
  onCancel: () => void;
}

const OAuthLoadingOverlay: React.FC<OAuthLoadingOverlayProps> = ({
  isOpen,
  provider,
  onCancel,
}) => {
  if (!isOpen) return null;

  return (
    <div className="oauth-loading-overlay zoomOutLevel">
      <div className="oauth-loading-overlay__card">
        <div className="oauth-loading-overlay__spinner" />
        <h3 className="oauth-loading-overlay__title">
          Signing in with {provider}…
        </h3>
        <p className="oauth-loading-overlay__message">
          Complete the sign-in in the opened window.
          <br />
          If you closed it, tap Cancel to try again.
        </p>
        <button
          type="button"
          onClick={onCancel}
          className="oauth-loading-overlay__cancel-btn"
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default OAuthLoadingOverlay;
